import React from 'react';
import { Gamepad2 } from 'lucide-react';
import logo from '../asset/logo copy.jpg'
const Logo = ({ size = 24 }) => {
  return (
    <div className="relative">
    <div className="  rounded-full  ">
  <img 
    src={logo} 
    alt="Smart Clinic" 
    className="w-14 h-14 rounded-full"  // Fits inside without distortion
  />
</div>
    
    </div>
  );
};

export default Logo;